<template>
  <div>
    <FormManagerList :roleList="roleList" @success="refreshCurrentPage" ref="form"/>
    <BasicTable
      border
      hasOperate
      :loading="loading"
      :tableData="tableData"
      :pageSize="+pageOption.per_page"
      :currentPage="+pageOption.current_page"
      :total="+pageOption.total"
      @pageChange="pageChange"
      :columns="columns" >
      <template slot="tableOpeate">
        管理员列表&emsp;
        <AppButton size="small" type="primary" plain @click="addManager">
          <i class="fa fa-plus fa-lg icon"></i>新增管理员
        </AppButton>&emsp;
      </template>
      <template v-slot:operate="{ item }">
        <AppButton type="primary" plain size="small" @click="editManager(item)"><i class="fa fa-edit fa-lg icon" ></i>编辑</AppButton>
        <AppButton type="primary" plain size="small" @click="deleteManager(item)"><i class="fa fa-trash-o fa-lg icon"></i>删除</AppButton>
      </template>
    </BasicTable>
  </div>
</template>

<script>
import FormManagerList from './formManagerList.vue';
import { ManagerService } from '../../service/manager.service';
import { MessageBox } from 'element-ui';
const columns = [
  { name: '管理员用户名', key: 'username' },
  { name: '手机号', key: 'mobile' },
  { name: '角色类型', key: 'role_id' },
  { name: '最后登入IP', key: 'last_ip' },
  { name: '操作', key: 'operate', type: 'custom' }
]
export default {
    name: 'managerList',
    components: { FormManagerList },
    data() {
      return {
        tableData: [],
        columns,
        roleList: [],
        searchValues: {},
        loading: false,
        pageOption: {
          total: 0,
          current_page: 1,
          per_page: 20,
        }
      }
    },
    created() {
      this.getList()
    },
    methods: {
     async getList() {
        this.loading = true;
        this.selectItems = [];
        const data = await ManagerService.getManagerInfo({ rows: this.pageOption.per_page, page: this.pageOption.current_page, ...this.searchValues });
        this.loading = false;
        this.tableData = data.list.data;
        delete data.list.data;
        this.pageOption = data.list;
        data.role_list.map(item => {
          item.label = item.role_name;
          item.value = item.role_id;
        })
        this.roleList = data.role_list;
      },
      refreshCurrentPage() {
        this.pageChange(this.pageOption.current_page);
      },
      pageChange(index) {
        this.pageOption.current_page = index;
        this.getList();
      },
      addManager() {
        this.$refs.form.open('add', {});
      },
      async editManager(item) {
        const data = await ManagerService.getManager(item.id);
        this.$refs.form.open('edit', data);
      },
      async deleteManager(item) {
        await MessageBox.confirm('确定要删除这个管理员吗？', '删除管理员');
        await ManagerService.deleteManager(item.id);
        this.pageChange(1);
      }
    }
  }
</script>

<style lang="scss" scoped>

</style>